import { SWRConfig } from 'swr';
import type { SWRConfiguration } from 'swr';

import { ProductInfoDialog } from './containers';
import { ConfigurationProvider } from './context';
import type { AppConfiguration } from './models';

interface AppProps {
  configuration: AppConfiguration;
}

const swrConfig: SWRConfiguration = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,
};

export const App = ({ configuration }: AppProps) => (
  <SWRConfig value={swrConfig}>
    <ConfigurationProvider value={configuration}>
      <ProductInfoDialog />
    </ConfigurationProvider>
  </SWRConfig>
);
